import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../../lib/api";
import { Logo } from "../../components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("se_admin_token", data.token);
      nav("/admin");
    } catch (ex) {
      setErr(errMsg(ex, "Accesso non riuscito"));
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#FFFFFF]" data-testid="admin-login-page">
      <div className="hidden lg:block relative bg-[#1A1A1A]">
        <img src="/images/macro-vein.webp" alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />
      </div>
      <div className="flex flex-col justify-center px-8 sm:px-16 py-16">
        <Logo />
        <h1 className="f-serif font-light text-5xl mt-16">Pannello di gestione</h1>
        <p className="mt-3 text-[#555555]">Accesso riservato all’amministratore.</p>
        <form onSubmit={submit} className="mt-12 space-y-8 max-w-sm">
          <label className="block"><span className="eyebrow !text-[0.66rem] text-[#555555]">Email</span>
            <input className="field" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" /></label>
          <label className="block"><span className="eyebrow !text-[0.66rem] text-[#555555]">Password</span>
            <input className="field" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" /></label>
          {err && <p role="alert" className="text-sm text-[#8a3b2e]" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={busy} className="w-full min-h-[52px] bg-[#1A1A1A] text-[#FFFFFF] text-[0.8rem] tracking-[0.14em] uppercase disabled:opacity-50" data-testid="admin-login-submit">
            {busy ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </div>
    </main>
  );
}
